<template>
	<div class="mallproduct-payload">
		
		<div class="psearch">
			<van-sticky>
				<van-search 
					v-model="search.kws" 
					placeholder="请输入搜索关键词" 
					@search="onSearch"
				/>
			</van-sticky>
		</div>

		<div class="pitem">
			<van-row>
				<van-col :span="4">
					<div class="pitem-left">
						<van-sidebar v-model="querys.tabIdx">
							<template v-for="(item,idx) in categoryItem">
								<van-sidebar-item 
									:title="item.name"
									@click="handleClickCategory(idx)"
								/>
							</template>							
						</van-sidebar>
					</div>
				</van-col>

				<van-col :span="20">
					<div v-if="pageItem.length > 0" class="pitem-right">
						<van-list
							v-model="querys.loading"
							:finished="querys.finished"
							offset="50"
							finished-text="没有更多数据了！"
							@load="onNextPage"
						>
							<template v-for="(item,idx) in pageItem" >
								<van-cell>
									<template slot="icon">
										<van-image
											class="pimage"
											width="60"
											height="60"
											:src="item.productImage"
										/>
									</template>
									<template slot="title">
										{{item.productName}}
									</template>
									<template slot="label">
										<div class="row">{{item.skuLabel}}</div>
										<div class="row money">
											<span class="price">零售价:<span class="num">￥{{formatMoney(item.priceSale)}}</span>
											</span>
											<span class="price">券后价:<span class="num">￥{{formatMoney(item.priceCoupon)}}</span>
											</span>
										</div>
									</template>
									<template slot="right-icon">
										<div class="pright">
											<!-- <div>
												<van-icon 
													v-if="idx == 0"
													class="selected" 
													name="circle" 
													size="20px"
													color="#909399"
												/>
													<van-icon 
													v-if="idx == 1"
													class="selected" 
													name="passed" 
													size="20px" 
													color="#67C23A"
												/>
											</div> -->

											<van-tag 
												class="send"
												type="primary"
												size="medium"
												@click="handleSend(idx)"
											> 发送 </van-tag>

										</div>
									</template>
								</van-cell>
							</template>
						</van-list>
					</div>

					<div v-else class="pitem-right">
						<div v-if="querys.loading" class="load">
							<van-loading 
								size="36px"
								type="spinner"
							/>
						</div>
						<van-empty v-else description="暂无查询商品!" />
					</div>
				</van-col>
			</van-row>
		</div>

		<!--分享弹框-->
		<van-popup 
			v-model="send.show" 
			position="bottom" 
			:style="{ height: '60vh' }" 

		>
			<div class="send-payload">
				<div class="title">请选择发送方式</div>
				<div class="content">
					<!-- <van-row> -->
						<!-- <van-col :span="12">
							<div class="thalf">
								<div class="stext">
									<div class="stitle">{{send.text.title}}</div>
									<div class="slink">{{send.text.url}}</div>
								</div>
							</div>
						</van-col> -->
						<!-- <van-col :span="12"> -->
							<div class="thalf onehalf">
								<div class="tmini">
									<div class="ttitle">{{send.mini.title}}</div>
									
									<van-image
										class="timage"
										width="150"
										height="150"
										:src="send.mini.image"
									/>
								</div>
							</div>
						<!-- </van-col> -->
					<!-- </van-row> -->
				</div>
				<van-tabbar v-model="send.type">
					<!-- <van-tabbar-item icon="link-o" @click="handlClickShare('text')">发送文字链接</van-tabbar-item> -->
					<van-tabbar-item icon="miniprogram-o" @click="handlClickShare('mini')">发送小程序</van-tabbar-item>
				</van-tabbar>
			</div>
		</van-popup>
	</div>
</template>
<script type="text/javascript">
import {wxminiCfg} from '@/config/wxmini';
import {getQwSignature} from '@/interface/qywx/qwglobal';

import {getCategory,getSkus} from '@/interface/oms/pmall/product/product';
export default {
	data(){
		return {
			//企业微信签名信息
			qywxCfg: {
				agentId: '',
				corpId: '',
				url: '',
				corpTimestamp: '',
				corpNonceStr: '',
				corpSignature: '',
				agentTimestamp: '',
				agentNonceStr: '',
				agentSignature: '',
			},
			qywxCurrent:{
				thirdCode:'qywx',	//来源
				chatId: '',		//当前群ID
				agent: 'oms',	//当前应用
			},
			querys:{
				tabIdx: '',
				loading: false,
				finished: true
			},
			send:{
				type: '',
				show: false,
				currentIdx: '',
				text:{
					title: '',
					url: ''
				},
				mini:{
					title: '',
					image: ''
				}	
			},
			categoryItem:[],
			search:{
				kws: '',
				page: 1,
				psize: 10,
				orby: '',
				sort: '',
				categoryId: ''
			},
			pageItem:[]
		}
	},
	created: function() {
		this.getQywxCfg();

		this.getCategory();
		this.onSearch();
	},
	methods:{
		handleSend: function(idx){
			let current = this.pageItem[idx];

			let title = current.productName+' '+current.skuLabel+' ('+current.priceSale+'元)';

			this.send.text = {
				title: title,
				url: '分享短连接',
			}

			this.send.mini = {
				label: title,
				title: title,
				image: current.productImage,
				url: 'pmall/product/detail/detail.html?productId='+current.productId+'&skuId='+current.skuId
			}

			this.send.currentIdx = idx;
			this.send.show = true;
		},
		handlClickShare: function(type){
			if( type == 'mini' ){
				let miniData = {
					title: this.send.mini.title,
					imgUrl: this.send.mini.image,
					page: this.send.mini.url
				}

				this.sendMiniProgram( miniData );
				this.send.show = false;
			}
		},
		getCategory: function(){
			getCategory()
				.then(res=>{
					if( res.status && res.response.length > 0 ){
						this.categoryItem = res.response;
					}

					let row = {id:0, name: '全部'};
					this.categoryItem.unshift(row);
				})
				.catch(err=>{})
		},
		handleClickCategory: function(idx){
			let current = this.categoryItem[idx];
			this.search.categoryId = current.id;

			this.onSearch();
		},
		onSearch: function(){
			this.search.page = 1;
			this.pageItem = [];

			this.getPageData(this.search);
		},
		onNextPage: function(){
			this.search.page = this.search.page + 1;

			this.getPageData(this.search);
		},
		getPageData: function(search){
			this.querys.loading = true;
			getSkus(search)
				.then(res=>{
					if( res.status && ('item' in res.response) ){

						if( res.response.item.length > 0 ){
							let _this = this;
							res.response.item.forEach( function(item){
								let row = {
									productId: item.productId,
									skuId: item.skuId,
									productName: item.productName,
									productImage: item.productImage,
									remark: item.remark,
									type: item.type,
									skuLabel: item.skuLabel.join('/'),
									priceSale: item.priceSale,
									priceCoupon: item.priceCoupon
								}

								_this.pageItem.push(row);
							})
						}

						this.querys.finished = this.pageItem.length >= res.response.total;
					}

					this.querys.loading = false;
				})
				.catch(err=>{})
		},
		formatMoney: function(money){
			return parseFloat(money).toFixed(2);
		},
		//获取企业微信签名信息
		getQywxCfg: function(){
			let data = {
				app: 'oms',
				url: window.location.href.split('#')[0],
			}

			getQwSignature(data)
				.then( res=>{
					let info = res.response;
					this.qywxCfg = {
						corpId: info.corpId,
						agentId: info.agentId,
						url: info.url,
						corpSignature: info.corpSignature,
						corpTimestamp: info.corpTimestamp,
						corpNonceStr: info.corpNonceStr,
						agentSignature: info.agentSignature,
						agentTimestamp: info.agentTimestamp,
						agentNonceStr: info.agentNonceStr,
					}

					this.qywxInit();
				})
				.catch( err=>{

				})
		},
		//企业微信初始化
		qywxInit: function(){
			let _this = this;

			ww.register({
				corpId: _this.qywxCfg.corpId,       // 必填，当前用户企业所属企业ID
				agentId: _this.qywxCfg.agentId,  // 必填，当前应用的AgentID
				jsApiList: ['getContext','getCurExternalChat','sendChatMessage'], // 必填，需要使用的JSAPI列表
				getConfigSignature,
				getAgentConfigSignature,            // 必填，根据url生成应用签名的回调函数
				onConfigSuccess(res){
					// alert('configSuccess:'+JSON.stringify(res));
				},
				onConfigFail(res){
					alert('企业签名获取失败:'+JSON.stringify(res));
				},
				onConfigComplete(res){
					// alert('configComplete:'+JSON.stringify(res));
				},
				onAgentConfigFail(res){
					alert('应用签名获取失败:'+JSON.stringify(res));
				},          
				onAgentConfigComplete(res){
					// alert('onAgentConfigComplete:'+JSON.stringify(res));
				}				
			})

    		// 根据 url 生成企业签名
			async function getConfigSignature(url) {
				// alert( 'getConfigSignature:'+JSON.stringify(_this.qywxCfg) );
				
				return {
					timestamp: _this.qywxCfg.corpTimestamp,
					nonceStr: _this.qywxCfg.corpNonceStr,
					signature: _this.qywxCfg.corpSignature
				};
			}

			// 根据 url 生成应用签名，生成方法同上，但需要使用应用的 jsapi_ticket
			async function getAgentConfigSignature(url) {
				// alert( 'getAgentConfigSignature:'+JSON.stringify(_this.qywxCfg) );

				return { 
					timestamp: _this.qywxCfg.agentTimestamp,
					nonceStr: _this.qywxCfg.agentNonceStr,
					signature: _this.qywxCfg.agentSignature
				};
			}

			//获取当前群ID
			this.handleCurExternalChat();
		},
		//获取当前群ID
		handleCurExternalChat: function(){
			let _this = this;
			ww.getCurExternalChat({
				success(res){
					_this.qywxCurrent.chatId = res.chatId;
				},
				fail(err){
					alert('群ID获取失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('ExternalChat-complete:'+JSON.stringify(res));
				}
			})
		},
		/**
		 *分享小程序
		 *@param map miniData 小程序参数
		 *			title: 	标题
		 *			imageUrl 图片路径，以.html结尾
		 *			page:   跳转路径
		 */
		sendMiniProgram: function(miniData){
			let pageUrl = miniData.page;
				pageUrl+= '&thirdCode='+this.qywxCurrent.thirdCode;
				pageUrl+= '&agent='+this.qywxCurrent.agent;
				pageUrl+= '&chatId='+this.qywxCurrent.chatId;

			ww.sendChatMessage({
				msgtype: 'miniprogram',
				miniprogram: {
					appid: wxminiCfg.newClient.appId,
					title: miniData.title,
					imgUrl: miniData.imgUrl,
					page: pageUrl,
				},
				success(res){
					// alert('小程序发送成功:'+JSON.stringify(res));
				},
				fail(err){
					// alert('小程序发送失败:'+JSON.stringify(res));
				},
				complete: function(res){
					// alert('handleMiniProgram-complete:'+JSON.stringify(res));
				}
			})
		},
	}
}
</script>